import { Stack, Typography } from "@mui/material";
import { TriangleIcon } from "../images";

type Props = {
  isExpanded: boolean;
  expandHandler: () => void;
  total: number;
  isStartIcon?: boolean;
};

export const ShowAllAccountsBlock = ({
  isExpanded,
  expandHandler,
  total,
  isStartIcon = true,
}: Props) => {
  const icon = (
    <div style={{ width: "18px" }}>
      <TriangleIcon color={"#1C3C6C"} rotate={isExpanded ? "180" : "0"} />
    </div>
  );
  return (
    <Stack
      onClick={expandHandler}
      sx={{
        flexDirection: "row",
        gap: "8px",
        alignItems: "center",
        cursor: "pointer",
        alignSelf: "flexStart",
      }}
    >
      {isStartIcon && icon}
      <Typography
        variant={"button"}
        sx={{ color: "#1C3C6C", textWrap: "nowrap" }}
      >
        {isExpanded ? "Show Less" : `Show all Accounts (${total})`}
      </Typography>
      {!isStartIcon && icon}
    </Stack>
  );
};
